import { CaseDocument, DocumentCardinality, DocumentScope, DocumentType } from "../../../../src/api/caseDocuments";
import { DOCUMENT_CONFIG } from "../config/DocumentConfig";

export interface DuplicateResult {
  duplicate: boolean;
  existingDoc: CaseDocument | null;
  reason: DuplicateReason | null;
  message: string | null;
}

export enum DuplicateReason {
  SameDocumentName = "same-document-name",
  SameDocumentType = "same-document-type",
  SameDocumentTypeSameParty = "same-document-type-same-party",
}


export function checkDuplicate(
  documents: CaseDocument[],
  documentType: DocumentType,
  entityId: string | null,
  fileName: string
): DuplicateResult {
  const config = DOCUMENT_CONFIG[documentType];
  const incomingName = fileName.toLowerCase();

  for (const doc of documents) {
    const existingName = doc.file_name.toLowerCase();

    const sameType = doc.document_type === documentType;
    const sameName = existingName === incomingName;
    const sameParty = doc.entity_id === entityId;

    const existingLabel = DOCUMENT_CONFIG[doc.document_type].dropdownLabel;


    if (config.scope === DocumentScope.CASE && config.cardinality === DocumentCardinality.SINGLETON) {
      if (sameName) {
        return {
          duplicate: true,
          existingDoc: doc,
          reason: DuplicateReason.SameDocumentName,
          message: `A document named "${doc.file_name}" already exists. Do you want to replace it?`,
        };
      }
      if (sameType) {
        return {
          duplicate: true,
          existingDoc: doc,
          reason: DuplicateReason.SameDocumentType,
          message: `The ${existingLabel} already exists. Do you want to replace it?`,
        };
      }
    }

    if (config.scope === DocumentScope.PARTY && config.cardinality ===DocumentCardinality.SINGLETON) {
      if (sameName) {
        return {
          duplicate: true,
          existingDoc: doc,
          reason: DuplicateReason.SameDocumentName,
          message: `A document named "${doc.file_name}" already exists. Do you want to replace it?`,
        };
      }
      if (sameType && sameParty) {
        return {
          duplicate: true,
          existingDoc: doc,
          reason: DuplicateReason.SameDocumentTypeSameParty,
          message: `The ${existingLabel} for the same Party Name already exists. Do you want to replace it?`,
        };
      }
    }

    if (config.cardinality === DocumentCardinality.MULTIPLE && sameName) {
      return {
        duplicate: true,
        existingDoc: doc,
        reason: DuplicateReason.SameDocumentName,
        message: `A document named "${doc.file_name}" already exists. Do you want to replace it?`,
      };
    }
  }

  return {
    duplicate: false,
    existingDoc: null,
    reason: null,
    message: null,
  };
}



